var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.75C0 0.784 0.784 0 1.75 0H6.721C7.301 0 7.841 0.286 8.168 0.765L9.572 2.828C9.59488 2.86186 9.62572 2.88959 9.66181 2.90877C9.6979 2.92794 9.73813 2.93798 9.779 2.938H18.25C19.216 2.938 20 3.721 20 4.688V16.25C20 16.7141 19.8156 17.1592 19.4874 17.4874C19.1592 17.8156 18.7141 18 18.25 18H1.75C1.28587 18 0.840752 17.8156 0.512563 17.4874C0.184375 17.1592 0 16.7141 0 16.25V1.75Z",
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFilled);
export default __webpack_public_path__ + "static/media/folder-filled.437ffb37d2a8c7fdcb977b3c008bf09f.svg";
export { ForwardRef as ReactComponent };